import { Injectable, Type } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { DrawerRef } from "./drawer-ref";
import { MatDialog } from "@angular/material/dialog";
import { SearchUnitModal } from "../components/shared/search-units/modal/modal.component";

export interface FabButtonAction {
  backgroundClass: string;
  iconClass: string;
  title: string;
  action: () => void;
}

@Injectable({
  providedIn: "root",
})
export class FabButtonService {
  private $buttons = new BehaviorSubject<FabButtonAction[]>([]);
  buttons$ = this.$buttons.asObservable();

  btnLocalizar = {
    backgroundClass: "bg-blueGray-700 hover:w-52",
    iconClass: "fas fa-search",
    title: "Localizar unidades",
    action: () => {
      this.open();
    },
  };

  constructor( public dialog: MatDialog) {
    this.setDefaultButtons();
  }

  addButton(action: FabButtonAction) {
    this.$buttons.next([...this.$buttons.value, action]);
  }

  removeButton(action: FabButtonAction) {
    this.$buttons.next(this.$buttons.value.filter((btn) => btn !== action));
  }

  setButtons(actions: FabButtonAction[]) {
    this.$buttons.next(actions);
  }

  setDefaultButtons() {
    this.$buttons.next([this.btnLocalizar]);
  }

  setBlacklistButtons() {
    this.$buttons.next([this.btnLocalizar]);
  }
  clearButtons() {
    this.$buttons.next([]);
  }

  open() {
    this.dialog
      .open(SearchUnitModal, {
        panelClass: [
          "modal-for-search-box",
          "overflow-hidden",
          "w-full",
          "lg:w-1/2",
        ],
      })
      .afterClosed()
      .toPromise();
  }
}
